"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_transition_group_1 = require("react-transition-group");
var constants_1 = require("../constants");
var DefaultToast_1 = __importDefault(require("../DefaultToast"));
var ToastContainer_1 = __importDefault(require("../ToastContainer/ToastContainer"));
var ToastContext_1 = __importDefault(require("../ToastContext"));
var ToastController_1 = __importDefault(require("../ToastController"));
var utils_1 = require("../utils");
var canUseDOM = !!(typeof window !== "undefined" &&
    window.document &&
    window.document.createElement);
var ToastProvider = /** @class */ (function (_super) {
    __extends(ToastProvider, _super);
    function ToastProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { toasts: [] };
        _this.has = function (id) {
            if (!_this.state.toasts.length) {
                return false;
            }
            return Boolean(_this.state.toasts.filter(function (t) { return t.id === id; }).length);
        };
        _this.onDismiss = function (id, cb) {
            if (cb === void 0) { cb = utils_1.NOOP; }
            return function () {
                cb(id);
                _this.remove(id);
            };
        };
        _this.add = function (content, options, cb) {
            if (options === void 0) { options = {}; }
            if (cb === void 0) { cb = utils_1.NOOP; }
            var id = options.id || utils_1.generateUEID();
            var callback = function () { return cb(id); };
            if (_this.has(id)) {
                return;
            }
            _this.setState(function (state) {
                var newToast = __assign({ content: content, id: id }, options);
                var toasts = __spreadArrays(state.toasts, [newToast]);
                return { toasts: toasts };
            }, callback);
            return id;
        };
        _this.remove = function (id, cb) {
            if (cb === void 0) { cb = utils_1.NOOP; }
            var callback = function () { return cb(id); };
            if (!_this.has(id)) {
                return;
            }
            _this.setState(function (state) {
                var toasts = state.toasts.filter(function (t) { return t.id !== id; });
                return { toasts: toasts };
            }, callback);
        };
        _this.removeAll = function () {
            if (!_this.state.toasts.length) {
                return;
            }
            _this.state.toasts.forEach(function (t) { return _this.remove(t.id); });
        };
        _this.update = function (id, options, cb) {
            if (options === void 0) { options = {}; }
            if (cb === void 0) { cb = utils_1.NOOP; }
            var callback = function () { return cb(id); };
            if (!_this.has(id)) {
                return;
            }
            _this.setState(function (state) {
                var old = state.toasts;
                var i = old.findIndex(function (t) { return t.id === id; });
                var updatedToast = __assign(__assign({}, old[i]), options);
                var toasts = __spreadArrays(old.slice(0, i), [updatedToast], old.slice(i + 1));
                return { toasts: toasts };
            }, callback);
        };
        return _this;
    }
    ToastProvider.prototype.render = function () {
        var _this = this;
        var _a = this.props, inheritedAutoDismiss = _a.autoDismiss, autoDismissTimeout = _a.autoDismissTimeout, children = _a.children, components = _a.components, placement = _a.placement, transitionDuration = _a.transitionDuration;
        var _b = __assign({}, components), Toast = _b.Toast, ToastContainer = _b.ToastContainer;
        var _c = this, add = _c.add, remove = _c.remove, removeAll = _c.removeAll, update = _c.update;
        var toasts = Object.freeze(this.state.toasts);
        var hasToasts = Boolean(toasts.length);
        var portalTarget = canUseDOM ? document.body : null;
        return (react_1["default"].createElement(ToastContext_1["default"].Provider, { value: { add: add, remove: remove, removeAll: removeAll, update: update, toasts: toasts } },
            children,
            portalTarget ? (react_dom_1.createPortal(react_1["default"].createElement(ToastContainer, { placement: placement, hasToasts: hasToasts },
                react_1["default"].createElement(react_transition_group_1.TransitionGroup, { component: null }, toasts.map(function (_a) {
                    var appearance = _a.appearance, autoDismiss = _a.autoDismiss, content = _a.content, id = _a.id, onDismiss = _a.onDismiss, unknownConsumerProps = __rest(_a, ["appearance", "autoDismiss", "content", "id", "onDismiss"]);
                    return (react_1["default"].createElement(react_transition_group_1.Transition, { appear: true, key: id, mountOnEnter: true, timeout: transitionDuration, unmountOnExit: true }, function (transitionState) { return (react_1["default"].createElement(ToastController_1["default"], __assign({ appearance: appearance, autoDismiss: autoDismiss !== undefined
                            ? autoDismiss
                            : inheritedAutoDismiss, autoDismissTimeout: autoDismissTimeout, component: Toast, key: id, onDismiss: _this.onDismiss(id, onDismiss), placement: placement, transitionDuration: transitionDuration, transitionState: transitionState }, unknownConsumerProps), content)); }));
                }))), portalTarget)) : (react_1["default"].createElement(ToastContainer, { placement: placement, hasToasts: hasToasts }) // keep ReactDOM.hydrate happy
            )));
    };
    ToastProvider.defaultProps = {
        autoDismiss: false,
        autoDismissTimeout: constants_1.DEFAULT_AUTO_DISMISS_TIMEOUT,
        components: { Toast: DefaultToast_1["default"], ToastContainer: ToastContainer_1["default"] },
        placement: constants_1.DEFAULT_PLACEMENT,
        transitionDuration: constants_1.DEFAULT_TRANSITION_DURATION
    };
    return ToastProvider;
}(react_1.Component));
exports["default"] = ToastProvider;
